import type { Selection } from "../../charts/utils";
import marketDataRaw from "../../data/market-data.json";
import { getLevel4SelectionKey } from "../emissions/data-config";

export type MarketSeriesKey = "totalbestand" | "withEnova" | "withoutEnova";

export const MARKET_LINE_LABELS: Record<MarketSeriesKey, string> = {
    totalbestand: "Totalbestand",
    withEnova: "Antall fossilfrie, utvikling med Enova",
    withoutEnova: "Antall fossilfrie, utvikling uten Enova",
};

export const formatVehicleValue = (value?: number) => {
    if (typeof value !== "number") {
        return "0";
    }

    return new Intl.NumberFormat("nb-NO", {
        maximumFractionDigits: 0,
    }).format(Math.round(value));
};

export type MarketDataPoint = {
    year: number;
    totalbestand: number;
    withEnova: number;
    withoutEnova: number;
};

const marketData = marketDataRaw as Record<string, MarketDataPoint[]>;

export function getMarketDataForSelection(selection: Selection): MarketDataPoint[] | null {
    const configKey = getLevel4SelectionKey(selection);
    if (!configKey) {
        return null;
    }
    return marketData[configKey] ?? null;
}
